module.exports = __webpack_public_path__ + "static/media/myAccountHelpPlaceholder.ba7d2b5c.svg";